import { Component, OnInit } from '@angular/core';
import { AuthService } from '../_services/auth.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  public frmSignup: FormGroup;

  errorMessage = '';
  isResetPasswordFailed = false;
  isLoading = false;

  constructor(private authService: AuthService, private router: Router, private fb: FormBuilder) { 
    this.frmSignup = this.createSignupForm();
  }

  ngOnInit(): void {
  }

  createSignupForm(): FormGroup {
    return this.fb.group(
      {
        email: [
          null,
          Validators.compose([Validators.email, Validators.required])
        ],
      },
    );
  }

  onSubmit(): void {

    const passwordResetUrl = environment.passwordResetUrl;

    this.isLoading = true;
    this.isResetPasswordFailed = false;

    this.authService.resetPasswordToken(this.frmSignup.value.email, passwordResetUrl).subscribe(
      data => {
        this.isLoading = false;
        this.isResetPasswordFailed = false;
      },
      err => {
        this.isLoading = false;
        if (err.error instanceof ProgressEvent) {
          this.errorMessage = 'Unable to reach the server. Please check your internet connection and try again.';
        } else {
          this.errorMessage = err.error || err.message || 'An error occurred. Please try again.';
        }
        this.isResetPasswordFailed = true;
      }
    );
  }

  goToLogin(): void {
    this.router.navigate(['login/']);
  }
}
